import { Link } from "react-router-dom";

function QuadArt(props) {
  return (

    <Link to={props.pagina} data-toggle="lightbox" data-gallery="example-gallery" className="col-sm-3 box">
    
    
        <img src={props.img} className="img-fluid" alt="fig" />
        <div className="overlay">
            <img src="images/plus-img.png" alt="plus-icon" />
            <div className="inner-text"><h4>{props.text1}<span>{props.text2}</span></h4></div>
        </div>
    
    
    </Link>
  );
}

export default QuadArt;
